import React from "react";
import { LANDING_MENU_BAR } from "../../constants/strings/StringsDashboard";
import Tag from "../../miscellaneous/Tags/Tag";
import Graphics from "./PISCCGraphicsComponent"

const Piscc = (props) => {
  return (
    <>
      <div>
        <div className="page-title" style={{ fontWeight: "bold" }}>
          {LANDING_MENU_BAR.PISCC_INDICATORS}
        </div>
        <div>
          <div className="line line-10"></div>
          <div className="line line-20">
            <label className="input-text">Alcance</label>
            <div className="div-select-form">
              <select onChange={(e) => props.onChange('alcance', e.target.value)} value='0'>
                <option value='0' disabled={true}>Seleccione Nivel</option>
                {
                  props.alcance.map(a => <option value={a.id} key={`select-option-nivel-key-${a.id}`}>{a.text}</option>)
                }
              </select>
            </div>
          </div>
          <div className="line line-20">
            <label className="input-text">Nivel de alcance</label>
            <div className="div-select-form">
              <select onChange={(e) => props.onChange('nivelAlcance', e.target.value)} value='0'>
                <option value='0' disabled={true}>Seleccione Alcance Nivel</option>
                {
                  props.nivelAlcance.map(a => <option value={a.id} key={`select-option-nivel-alcance-key-${a.id}`}>{a.text}</option>)
                }
              </select>
            </div>
          </div>
          <div className="line line-20">
            <label className="input-text">Año</label>
            <div className="div-select-form">
              <select onChange={(e) => props.onChange('year', e.target.value)} value='0'>
                <option value='0' disabled={true}>Seleccione Año</option>
                <option value='2020'>2020</option>
                <option value='2021'>2021</option>
                <option value='2022'>2022</option>
                <option value='2023'>2023</option>
              </select>
            </div>
          </div>
          <div className="line line-20">
            <label className="input-text">Buscar</label>
            <div className="div-input-form">
              <input
                type="text"
                placeholder="Ingrese la palabra clave para realizar la busqueda"
                value={props.state.texto}
                onKeyDown={props.handlerKeyPress}
                onChange={(e) => props.onChange('texto', e.target.value)}
              />
            </div>
          </div>
        </div>
        <div className="filter" style={{ minHeight: '58px' }}>
          {props.state.filterArray.map((t, index) => (
            <Tag
              key={`tag-key-id-${t.id}-index-${index}`}
              item={t}
              buttonHandler={() => props.onChange(t.variable, t.id)}
            />
          ))}
          {props.state.content.filter(f => f.active).map(t => (
            <div className="filter-text-button" key={`tag-key-item-${t.id}`}>
              <div><p>{t.linea}</p></div>
              <i className="far fa-times-circle filter-button-icon" onClick={() => props.closeTagText(t.id)}></i>
            </div>
          ))}
        </div>
        <div>
          <Graphics state={props.state}/>
        </div>
      </div>
    </>
  );
};

export default Piscc;
